<router-outlet></router-outlet>

<!-- Notification Bar -->
<!-- <app-notification-bar></app-notification-bar> -->